/**
 * <mb-header>: cabeçalho (portado de common/header.js do tema anterior).
 * - Classes de rolagem no #header: on-top, scroll-up, scroll-down.
 * - Busca mobile: [data-toggle-search] alterna body.search-open.
 * - 3º nível do mega menu: [data-show-submenus] mostra/esconde os itens .-dynamic (VER MAIS / VER MENOS).
 * - Faixa de serviços: Swiper (autoplay) somente até 991 px, com 2+ slides.
 */
const { loadSwiper } = window.MB;

class MbHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('#header') || this;
    this.lastScrollTop = 0;
    this.setScroll(window.scrollY);
    window.addEventListener(
      'scroll',
      () => {
        const top = window.scrollY;
        this.setScroll(top);
        this.lastScrollTop = top;
      },
      { passive: true }
    );

    document.querySelectorAll('[data-toggle-search]').forEach((button) => {
      button.addEventListener('click', () => {
        const open = document.body.classList.toggle('search-open');
        if (open) this.querySelector('.search input')?.focus();
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') document.body.classList.remove('search-open');
    });

    this.querySelectorAll('[data-show-submenus]').forEach((button) => {
      button.addEventListener('click', () => this.toggleSubmenu(button));
    });

    this.setServicesSwiper();
  }

  setScroll(scrollTop) {
    const { classList } = this.header;
    if (scrollTop <= 0) {
      classList.add('scroll-up', 'on-top');
      classList.remove('scroll-down');
      return;
    }
    classList.remove('on-top');
    if (scrollTop > this.lastScrollTop) {
      classList.add('scroll-down');
      classList.remove('scroll-up');
    } else {
      classList.add('scroll-up');
      classList.remove('scroll-down');
    }
  }

  toggleSubmenu(button) {
    const container = button.closest('[data-submenus-container]');
    if (!container) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    container.querySelectorAll('.sub-list-item.-dynamic').forEach((item) => {
      item.hidden = expanded;
    });
    button.setAttribute('aria-expanded', String(!expanded));
    button.textContent = expanded ? button.dataset.textMore : button.dataset.textLess;
  }

  setServicesSwiper() {
    const services = this.querySelector('.services');
    if (!services || window.innerWidth > 991) return;
    const slides = services.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;
    loadSwiper(services.dataset.swiperSrc).then((Swiper) => {
      this.servicesSwiper = new Swiper(services, {
        slidesPerView: 1,
        watchOverflow: true,
        speed: 1000,
        loop: true,
        autoplay: { delay: 3000 },
      });
    });
  }
}

if (!customElements.get('mb-header')) customElements.define('mb-header', MbHeader);
